import { Controller } from "@hotwired/stimulus";

// Fills the English fields of the Super Guia business form from the Portuguese ones.
// It only writes into the inputs — nothing is persisted until the editor saves the form,
// so every machine translation gets a human read first.
class GuiaTranslateController extends Controller {
  static targets = [
    "name",
    "sourceShort",
    "sourceDescription",
    "targetShort",
    "targetDescription",
    "button",
    "status",
  ];

  static values = { url: String };

  // TipTap emits <p></p> for an editor that was opened and never typed into, so a raw
  // trim() would call the API with nothing to translate.
  static blankHtml(value) {
    return value.replace(/<[^>]*>/g, "").replace(/&nbsp;|&#160;/g, " ").trim() === "";
  }

  async translate() {
    const short = this.sourceShortTarget.value.trim();
    const rawDescription = this.hasSourceDescriptionTarget
      ? this.sourceDescriptionTarget.value.trim()
      : "";
    const description = GuiaTranslateController.blankHtml(rawDescription)
      ? ""
      : rawDescription;

    if (!short && !description) {
      this.report("Preencha os textos em português primeiro.");
      return;
    }

    this.setBusy(true);

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({
          name: this.hasNameTarget ? this.nameTarget.value : "",
          short_description: short,
          description,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        this.report(data.error || "Não foi possível traduzir agora.");
        return;
      }

      this.fill(this.targetShortTarget, data.short_description);
      if (this.hasTargetDescriptionTarget) {
        this.fillEditor(this.targetDescriptionTarget, data.description);
      }

      this.report("Tradução preenchida. Revise antes de salvar.");
    } catch (error) {
      this.report("Não foi possível traduzir agora.");
    } finally {
      this.setBusy(false);
    }
  }

  fill(field, value) {
    if (!value) return;

    field.value = value;
    field.dispatchEvent(new Event("input", { bubbles: true }));
    field.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // A TipTap field needs an explicit hand-off: its React editor reads the hidden input only
  // at mount, so setting .value alone would leave the visible editor empty and let the next
  // keystroke overwrite the translation.
  fillEditor(field, value) {
    if (!value) return;

    field.dispatchEvent(
      new CustomEvent("tiptap:set-content", { detail: { html: value } })
    );
  }

  setBusy(busy) {
    if (!this.hasButtonTarget) return;

    this.buttonTarget.disabled = busy;
    this.buttonTarget.dataset.originalText ||= this.buttonTarget.innerText;
    this.buttonTarget.innerText = busy
      ? "Traduzindo…"
      : this.buttonTarget.dataset.originalText;
  }

  report(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message;
  }
}

export default GuiaTranslateController;
